import React from 'react';
import { useSelector } from 'react-redux';
import { selectInfiniteResources } from 'store/resources/selectors';
import { useInfiniteContent } from '../use-infinite-content.hook';
import { ResourcesSet } from './resources-set';

interface InfiniteViewProps {
  toggleReverseAnimation: VoidFunction;
  toggleModalSlideAnimation: VoidFunction;
  scrollContainerRef: React.MutableRefObject<HTMLDivElement>;
}

export const InfiniteView = ({
  toggleReverseAnimation,
  toggleModalSlideAnimation,
  scrollContainerRef,
}: InfiniteViewProps): JSX.Element => {
  const { limitOfElements } = useInfiniteContent(scrollContainerRef);
  const infiniteResources = useSelector(selectInfiniteResources);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {Object.keys(infiniteResources)?.map(indexOfSet => (
        <ResourcesSet
          key={indexOfSet}
          indexOfSet={+indexOfSet}
          limitOfElements={limitOfElements}
          toggleReverseAnimation={toggleReverseAnimation}
          toggleModalSlideAnimation={toggleModalSlideAnimation}
        />
      ))}
    </>
  );
};
